import React from "react";

const CashWallets = (props) => {
  // const [buttonText, setButtonText] = useState("View My Wallets");

  // // Handle Copy Button Click
  // const handleCopyClick = () => {
  //   const codeText = document.querySelector(".code mark").textContent;
  //   const textarea = document.createElement("textarea");
  //   document.body.appendChild(textarea);
  //   textarea.value = codeText;
  //   textarea.select();

  //   try {
  //     document.execCommand("copy");
  //     setButtonText("Copied!");

  //     // Reset text after 2 seconds
  //     setTimeout(() => {
  //       setButtonText("Copy");
  //     }, 2000);
  //   } catch (err) {
  //     console.error("Copy failed", err);
  //   }

  //   document.body.removeChild(textarea);
  // };

  return (
    <section
      id="id_memecoin_service_section"
      className={`memecoin_service_section bg-white  section_space z-2 pt-0 pb-5 position-relative ${props.tokenClass}`}
    >
      <div class="container">
        <div class="row justify-content-center">
          <div className="col-lg-7">
            <div className="px-4 py-4">
              <div className="mt-4">
                <h1 className=" text-theme text-center ">
                  Important Tax Information Cash Wallets Only
                </h1>
                <p className="text-dark text-center opacity-50">
                  TopCoin UK - Transparency, Trust, and Rewards You Can Rely On.
                </p>
              </div>
            </div>
            <div className="card shadow-sm border border-opacity-50 bg-white mb-3">
              <div className="card-body">
                <h5 className="text-dark-emphasis">
                  At TopCoin UK, your rewards come in two forms:
                </h5>
                <ul className="mb-0 text-dark-emphasis">
                  <li>Unit Wallets (which help you unlock new levels)</li>
                  <li>Cash Wallets (which hold real money you can withdraw)</li>
                </ul>
                <div className="bg bg-light-subtle mt-3 text-theme p-3 border rounded-3">
                  {/* <p className="mb-0 small">Please Note:</p> */}
                  <p className="mb-0">
                    When you withdraw money from any of your Cash Wallets, the
                    amount may be subject to tax.
                  </p>
                </div>
                <div className="text-center py-2 mb-0">
                  <p className="text-dark-emphasis">
                    This applies only to cash withdrawals ,not to your units.
                  </p>
                </div>
              </div>
            </div>
            <div className="card bg-white  shadow-sm border border-opacity-5 mb-3">
              <div className="card-body min-h250">
                <h5 className="text-dark-emphasis py-2">
                  All Cash Wallets Are UK Based
                </h5>
                <ul className="mb-0 text-dark-emphasis ">
                  <li>All Cash Wallets are held and managed in the UK</li>
                  <li>
                    Any cash rewards you withdraw will be paid directly from the
                    UK
                  </li>
                  <li>
                    Taxes may apply based on your local or UK tax regulations
                  </li>
                </ul>
                <h5 className="text-dark-emphasis py-2">Summary</h5>
                <ul className="mb-0 text-dark-emphasis">
                  <li> You won’t pay tax on your units</li>
                  <li>Only cash payouts may be taxed</li>
                  <li>
                    We will provide basic documentation if needed for tax
                    declaration
                  </li>
                  <li>
                    It’s your responsibility to report earnings according to
                    your local tax laws
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div class="row justify-content-center ">
          <div className="col-lg-6">
            <p className="text-center text-dark opacity-50">
              Topcoin UK Transparency, Trust, and Rewards You Can Rely On.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CashWallets;
